module.exports = __webpack_public_path__ + "src/assets/games/16/19.jpg";